module.exports = __webpack_public_path__ + "img/img_install_01@2x.5ebd9df9.png";